import {
    big_win, he,
    inbigwin,
    inmoneyadd, mega_win,
    picture_convert,
    server_config, set_inanim, set_inbigwin, set_inmoneyadd,
    set_inwincount, set_server_result, super_win, wallet, wi
} from "../framework/src/engine/madnes/madnes_variables";
import {
    bet,
    madnes_end_round,
    madnes_get_atomic_bet,
    madnes_win_anim_reset,
    win
} from "../framework/src/engine/madnes/madnes";
import {
    madnes_add_img,
    madnes_set_alpha,
    madnes_set_pos,
    madnes_set_scale,
    madnes_set_texture,
    madnes_set_visible, madnes_sprite_set_frame_name
} from "../framework/src/engine/madnes/madnes_object";
import {
    get_init_special_state,
    get_result_special_state,
    get_result_specifics,
    show_bigwin_text
} from "./jokerboom_reels";
import {
    madnes_anim_add,
    madnes_anim_add_oncomplete_once,
    madnes_anim_play
} from "../framework/src/engine/madnes/madnes_anims";
import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {
    madnes_audio_fade_to, madnes_audio_get_volume, madnes_audio_is_playing,
    madnes_audio_loop,
    madnes_audio_set_volume, madnes_audio_stop
} from "../framework/src/engine/madnes/madnes_audio";
import {jb_print_reels} from "./jokerboom_core_printer";
import {
    anims_fadein_clock,
    anims_fadein_logo,
    anims_fadeout_clock,
    anims_fadeout_logo,
    fadeout_bonus_bg
} from "./jokerboom_anims";
import {boom_spins_count, set_boom_spins_count, set_wild_lock} from "./jokerboom_core_res_ctrl";
import {icons} from "./jokerboom_config";
import {madnes_tween_func, madnes_tween_to} from "../framework/src/engine/madnes/madnes_tween";

var bigWinPlayed = false;
export function ctrl_end_round(bwPlayed)
{
    if(inmoneyadd || inbigwin)
    {
        setTimeout(function() {
            ctrl_end_round(bigWinPlayed);
        }, 500);

        return;
    }

    bigWinPlayed = bwPlayed;

    madnes_win_anim_reset();

    // madnes_hide_stop();
    // madnes_hide_skip();

    // if(!bigWinPlayed) {
    // 	if(win > 0) {
    // 		madnes_show_skip();
    // 	} else {
    // 		madnes_show_stop();
    // 	}
    // }

    set_inwincount(false);
    set_inanim(false);
    set_inmoneyadd(false);
    set_inbigwin(false);

    if(win * 1 > 0)
    {
        ctrl_end_round_win(win);
        return;
    }

    ctrl_end_round_nowin();
}

function ctrl_end_round_nowin() {

    madnes_end_round();

// 	if(is_in_autostart()) {
// 		madnes_show_btns();
// 	}
//
// 	madnes_end_round(true, {}, {}, function() {
//
// 		madnes_hide_stop();
// 		madnes_hide_skip();
//
// 		if(bigWinPlayed) {
// 			madnes_show_btns();
// 		}
//
// 		madnes_show_btns();
// //		madnes_hide_stop();
//
// 		// madnes_recount_bet();
// 		// recount_balance(false);
// 		// win = 0;
//
// 		end_result_control();
// 	});
}

function ctrl_end_round_win() {

    madnes_end_round();

    // madnes_end_round(true, {}, {}, function() {
    //
    // 	madnes_hide_stop();
    // 	madnes_hide_skip();
    //
    // 	if(bigWinPlayed) {
    // 		madnes_show_btns();
    // 	}
    //
    // 	end_result_control();
    // });
}

function end_result_control()
{
    // madnes_on_end_round_recount(win);
    // madnes_on_round_end();
    // madnes_recount_bet();
    //
    //
    //
    //
    // madnes_show_btns();
    // madnes_hide_spin();
    //
    // autospin_force_enabled = false;
    //
    // if(is_in_autostart() || autospin_force) {
    // 	autospin_force = false;
    // 	madnes_rotate_start();
    // 	return;
    // }
}

export function jb_end_round_recalced() {
    check_bonus();
    set_inbigwin(false);
    set_server_result(null);
}


export function betmenu_choose()
{
    check_bonus();
    set_locked_wild(true);
}

export function ctrl_counter(time, from, to, onUpdate) {

    return new Promise(function(res) {

        var obj = { 'val': 0 };

        madnes_tween_to(obj, { 'val': to - from }, {
            'duration': time,
            'easing': madnes_tween_func("linear"),
            'update': function() {
                onUpdate(obj['val'] + from);
            },
            'callback': function() {
                onUpdate(obj['val'] + from);
                res();
            }
        });
    });
}

export function get_real_win()
{
    return win;
}

export function get_real_big_win(b)
{
    return big_win * b;
}

export function get_real_mega_win(b)
{
    return mega_win * b;
}

export function get_real_super_win(b)
{
    return super_win * b;
}

function get_add_win_time(base, b, won)
{
    /*var time = won * b / base;

    if(time > base) {
        return base;
    }

    return time;*/

    return base;

    //var time = won > get_real_big_win(b) ? base : (won / get_real_big_win(b)) * base;


    /*	if(time < 80) {
            time = 80;
        }
    */
    //return time;
}

function get_add_bigwin_time(base, b, won)
{
    return won > get_real_mega_win(b) ? base : won / get_real_mega_win(b) * base;
}

function get_add_megawin_time(base, b, won)
{
    return won > get_real_super_win(b) ? base : won / get_real_super_win(b) * base;
}

function get_add_superwin_time(base, b, won)
{
    return won > get_real_super_win(b) * 2.5 ? base : won / (get_real_super_win(b) * 2.5) * base;
}

function get_add_win_value(won, b)
{
    return (won > get_real_big_win(b) ? get_real_big_win(b) : won);
}

function get_add_bigwin_value(won, b)
{
    return (won > get_real_mega_win(b) ? get_real_mega_win(b) : won);
}

function get_add_megawin_value(won, b)
{
    return (won > get_real_super_win(b) ? get_real_super_win(b) : won);
}

function get_add_superwin_value(b)
{
    return get_real_super_win(b);
}

function ctrl_set_boom_spin_num(num)
{
    madnes_add_img("bs_num", "boom_spins_json", wi / 2, he / 2 - 120, 1, 0.5, 0.5, 10);
    madnes_sprite_set_frame_name("bs_num", num);
}

export function ctrl_set_win_text_bg(num, isFloat)
{
    var name = ctrl_get_win_text_bg_name(num, isFloat);

    if(!name) {
        madnes_set_visible("win_text_bg", false);
        return;
    }

    madnes_set_visible("win_text_bg", true);
    madnes_sprite_set_frame_name("win_text_bg", name);

}

function helpers_get_int_length(n)
{
    n = "" + n;
    var count = 0;

    for(var i = 0; i < n.length; i++) {

        if(n[i] == "." || n[i] == ",") {
            break;
        }

        count++;
    }

    return count;
}

function ctrl_get_win_text_bg_name(text, isFloat)
{
    var intLen = helpers_get_int_length(text);

    if(intLen === 0 || intLen > 9) {
        return;
    }

    var name = "null";

    if(isFloat) {
        name += "_euro";
    }

    name += "_" + intLen;

    return name;
}

function ctrl_hide_all_bigwin_texts() {
    madnes_set_visible("bigwins_bwin", false);
    madnes_set_visible("bigwins_mwin", false);
    madnes_set_visible("bigwins_swin", false);
}

export function ctrl_set_bigwin_type(type) {
    ctrl_hide_all_bigwin_texts();

    madnes_set_visible("bigwins_sparkle", !!type);

    type && madnes_set_visible(type, true);

    if(!type) {
        show_bigwin_text(false);
        madnes_set_visible("bubbles", false);
    }
}

export function ctrl_get_reel_symbol_name(reel, x, y)
{
    /*if(reel.length === 1) {
        reel = reel[0];
    }*/

    return picture_convert[reel[x][y]];
}

export function get_memory_index(b)
{
    var atomicBet = madnes_get_atomic_bet();
    return wallet.getBetSet().indexOf(atomicBet);

//	var coef = 1; //currency === "CZK" ? 10 : 100; //hotfix promo video
//
//	var i = bet_set.indexOf(b * coin_val * coef);
//
//	return i;
}

export var in_bonus = false;

function ctrl_is_in_bonus(b, memory)
{
    var mIdx = get_memory_index(b);
    var wildMemory = memory[mIdx];

//	if(wildMemory['featureCount'] < 1 && wildMemory['featureNumber'] > 0) {
//
//		return in_bonus;
//
//	} else if(wildMemory['featureCount'] === wildMemory['featureNumber']){
//
//		return false;
//
//	} else {
//		//console.log(wildMemory['featureNumber'] > 0 && wildMemory['featureCount'] !== wildMemory['featureNumber']);
//		return wildMemory['featureNumber'] > 0 && wildMemory['featureCount'] > 0;
//	}

    return wildMemory['featureNumber'] > 0 && /*wildMemory['featureCount'] > 0 &&*/ wildMemory['featureCount'] !== wildMemory['featureNumber'];
}

export function ctrl_init_bonus() {

    //console.log("ctrl_init_bonus");

    var wildMemory = get_init_special_state()['wildMemory'];
    var noJBReel = get_init_special_state()['noJBReel'];

//	in_bonus = false;

    if(ctrl_is_in_bonus(bet, wildMemory))
    {
        ctrl_set_bonus(wildMemory, true);
    }
    else
    {
        ctrls_unset_bonus(noJBReel, false, true);
    }

//	set_locked_wild(true, 0);
}

/**
 * @param {boolean} betChanged
 * @param {number=} animTimeout
 */
export function set_locked_wild(betChanged, animTimeout) {

    var noJBReel = get_init_special_state()['noJBReel'];
    var wildMemory = get_init_special_state()['wildMemory'];

    if(get_result_specifics()) {
        noJBReel = get_result_special_state()['noJBReel'];
        wildMemory = get_result_special_state()['wildMemory'];
    }

    animTimeout = animTimeout ? animTimeout : 0;

    var bi = get_memory_index(bet);
    var wildIndex = wildMemory[bi]['index'];

    set_wild_lock(wildIndex);

    //madnes_audio_stop("misc_timer");

    if(wildIndex > -1)
    {
        //console.log(betChanged, bi, bonus_memory_index);

        if(bi !== bonus_memory_index)
        {
            //console.warn(betChanged);
            if(betChanged)
            {
                start_locked = true;

                madnes_set_texture("reels_bufer_" + 0 + "_S" + (2 - wildIndex), "wild_locked_json");
                madnes_anim_add("reels_bufer_" + 0 + "_S" + (2 - wildIndex), "locked", icons["symbol_Wild_locked"]["anim"]);
                madnes_set_scale("reels_bufer_" + 0 + "_S" + (2 - wildIndex), 1.1, 1.1);

                madnes_anim_add_oncomplete_once("reels_bufer_" + 0 + "_S" + (2 - wildIndex), function() {
                    madnes_set_texture("reels_bufer_" + 0 + "_S" + (2 - wildIndex), "symbol_Wild_sprite_json");
                    madnes_set_scale("reels_bufer_" + 0 + "_S" + (2 - wildIndex), 1.1, 1.1);
                    start_locked = false;
                });

                //			setTimeout(function() {
                madnes_anim_play("reels_bufer_" + 0 + "_S" + (2 - wildIndex), "locked");
                //madnes_audio_play("misc_timer");
                //			}, animTimeout);
            }
            else
            {
                madnes_set_texture("reels_bufer_" + 0 + "_S" + (2 - wildIndex), "symbol_Wild_sprite_json");
            }

            set_bonus_memory_index(bi);
        }

    } else {

        set_bonus_memory_index(-1);

        for(var i = 0; i <= 2; i++)
        {
            var s = 2 - i;
            var symbolName = picture_convert[noJBReel[i]];
            madnes_set_texture("reels_bufer_" + 0 + "_S" + s, symbolName + "_sprite_json");
        }
    }
}

export function refresh_bonus_count(b, wildMemory)
{
    var bi = get_memory_index(b);

    set_boom_spins_count(wildMemory?.[bi]['featureNumber'] - wildMemory?.[bi]['featureCount']);
    madnes_set_text("bonus_count", boom_spins_count);
}

var bonus_memory_index = -1;
export function set_bonus_memory_index(val) {
    bonus_memory_index = val;
}

export function ctrl_set_bonus(wildMemory, fromInit)
{
    return new Promise(function(res) {

        //console.log("set_bonus");
        refresh_bonus_count(bet, wildMemory);

        if(in_bonus) {
            return;
        }

        in_bonus = true;

        //set_hue_background(true);

        madnes_set_pos("background2", 0, 0);
        madnes_set_visible("background2", true);
        madnes_set_alpha("background2", 1);
        madnes_set_visible("background", false);
        madnes_set_pos("background", -9999, -9999);

        // madnes_disable_bet_key_change = true;

        if(fromInit) {
            madnes_audio_loop("audio_bonus_bg");
            madnes_audio_set_volume("audio_bonus_bg", 0);

            setTimeout(function() {
                // madnes_disable_bet_key_change = false;
                //in_bonus = true;
                res();
            }, 1050);

        } else {
            madnes_audio_loop("audio_bonus_bg");
            madnes_audio_set_volume("audio_bonus_bg", 0);

            madnes_audio_fade_to("audio_bonus_bg", server_config["behavior"]["sound"]["background"]["bonusGameBackground"], 300, function() {

                //in_bonus = true;
                // madnes_disable_bet_key_change = false;
                res();
            });
        }

        //for(var i = 0; i < cylinder_pos.length; i++)
        //{
        madnes_set_visible("reels_bufer_" + 0 + "_S0", false);
        madnes_set_visible("reels_bufer_" + 0 + "_S1", false);
        madnes_set_visible("reels_bufer_" + 0 + "_S2", false);
        //}

        madnes_set_visible("clock", true);
        madnes_set_alpha("clock", 1);

        madnes_set_visible("game_logo", false);

        madnes_set_visible("wild_reel", true);
        madnes_set_visible("wild_reel_bg", true);

        madnes_set_visible("bonus_count", true);

        jb_print_reels();
    });
}

var start_locked = false;

function ctrls_unset_bonus(noJBReel, fromWin, force)
{
    return new Promise(function(res) {

        if(!in_bonus && !force) {
            res();
            return;
        }

        if(fromWin) {

            fadeout_bonus_bg().then(function() {
                //set_hue_background(false);
            });

        } else {
            //set_hue_background(false);
            madnes_set_pos("background2", -9999, -9999);
            madnes_set_visible("background2", false);
            madnes_set_visible("background", true);
            madnes_set_pos("background", 0, 0);
        }

        // madnes_disable_bet_key_change = true;

        if(madnes_audio_get_volume("audio_bonus_bg") === 0 || !madnes_audio_is_playing("audio_bonus_bg")) {
            // madnes_disable_bet_key_change = false;
        }

        madnes_audio_fade_to("audio_bonus_bg", 0, 300, function() {
            madnes_audio_stop("audio_bonus_bg");
            // madnes_disable_bet_key_change = false;
            //in_bonus = false;

            res();
        });

        in_bonus = false;

        madnes_set_visible("wild_reel", false);
        madnes_set_visible("wild_reel_bg", false);

        for(var i = 0; i <= 2; i++)
        {
            var s = 2 - i;
            var symbolName = picture_convert[noJBReel[i]];
            madnes_set_texture("reels_bufer_" + 0 + "_S" + s, symbolName + "_sprite_json");
        }

        madnes_set_visible("reels_bufer_" + 0 + "_S0", true);
        madnes_set_visible("reels_bufer_" + 0 + "_S1", true);
        madnes_set_visible("reels_bufer_" + 0 + "_S2", true);

        madnes_set_visible("game_logo", true);
        madnes_set_alpha("game_logo", 1);

        madnes_set_visible("clock", false);

        madnes_set_visible("bonus_count", false);

        jb_print_reels();

    });
}

export function ctrls_set_clock()
{
    return new Promise(function(res) {

        madnes_set_visible("clock", false);

        anims_fadeout_logo().then(function() {
            return anims_fadein_clock();
        }).then(res);
    });
}

function ctrls_set_logo()
{
    new Promise(function(res) {
        anims_fadeout_clock().then(function() {
            anims_fadein_logo();
        }).then(res);
    });
}

export function preload_win_particles() {
    madnes_set_pos("win_particle_preload", wi - 10, he - 10);
    madnes_set_visible("win_particle_preload", true);
}

export function hide_preload_win_particles() {
    madnes_set_pos("win_particle_preload", -9999, -9999);
    madnes_set_visible("win_particle_preload", false);
}

function preload_bigwin_particles()
{
    madnes_set_pos("bigwin_particle_preload", wi - 10, he - 10);
    madnes_set_visible("bigwin_particle_preload", true);
}

function hide_preload_bigwin_particles()
{
    madnes_set_pos("bigwin_particle_preload", -9999, -9999);
    madnes_set_visible("bigwin_particle_preload", false);
}

var bonus_inited = false;
function check_bonus(/*betChanged*/)
{
//	console.warn("check_bonus");

    //return new Promise(function(res) {

    var noJBReel = get_init_special_state()['noJBReel'];
    var wildMemory = get_init_special_state()['wildMemory'];

    if(get_result_specifics()) {
        noJBReel = get_result_special_state()['noJBReel'];
        wildMemory = get_result_special_state()['wildMemory'];
    }

    if(ctrl_is_in_bonus(bet, wildMemory))
    {
        ctrl_set_bonus(wildMemory, false);//.then(res);
    }
    else
    {
        ctrls_unset_bonus(noJBReel, false, bonus_inited === false); //.then(res);
    }

    bonus_inited = true;

    //});

}